<template>
  <v-dialog v-model="dialogUser" scrollable  persistent :overlay="false" max-width="500px" transition="dialog-transition">
    <v-card>
      <v-card-title primary-title>
        {{ dialogUserTitle }} <v-spacer></v-spacer> <v-btn color="black" icon @click="$emit('closeDialog')"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-text-field label="Name" v-model="editedUser.UserProfile.name"></v-text-field>
        <v-text-field label="Phone" v-model="editedUser.UserProfile.phone"></v-text-field>
        <v-text-field label="Address" v-model="editedUser.UserProfile.address"></v-text-field>
        <v-autocomplete :items= "$store.state.cities" v-model="editedUser.UserProfile.city" return-object item-text="city" item-value="city" label="City" hide-no-data hide-selected></v-autocomplete>
        <v-text-field label="Post Code" v-model="editedUser.UserProfile.postCode"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn block color="primary" @click="saveUser">{{ dialogUserBtn }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {

    data(){
      return {
        dialogUser: false,
        editedUser: { email:'', UserProfile: { name: '', city: { type: '' } } }
      }
    },

    computed:{
      dialogUserTitle(){
        return (this.editedUser.id) ? "Edit user" : "Add user"
      },
      dialogUserBtn(){
        return (this.editedUser.id) ? "Update" : "Save"
      },
      userEmail(){
        if(!this.editedUser.UserProfile.name || !this.editedUser.UserProfile.phone) return '';
        return (this.editedUser.UserProfile.name.substr(0,3) + this.editedUser.UserProfile.phone.substr(this.editedUser.UserProfile.phone.length-3, 3)).toLowerCase()+ '@goried.com'
      }
    },

    watch:{
      userEmail(val){
        return this.editedUser.email = val
      }
    },

    methods:{
      getUsers(){
        this.axios.get('users').then( (res) => {
          this.$store.commit('mutate', { prop: 'users', data: res.data })
        }).catch( (err) => {
          this.$store.commit('mutate', { prop: 'snackbar', data: { text: err.response.data.msg, value:true } })
        })
      },
      saveUser(){
        if(!this.editedUser.id){
          this.axios.post('users', this.editedUser).then( () => {
            this.getUsers()
            this.$emit('closeDialog', this.editedUser )
            this.$store.commit('mutate', { prop: 'snackbar', data: { text: 'Success!', value:true } })
          }).catch( (err) => {
            this.$store.commit('mutate', { prop: 'snackbar', data: { text: err.response.data.msg, value:true } })
          })
        } else {
          this.axios.put('users/' + this.editedUser.id, this.editedUser).then( () => {
            this.getUsers()
            this.$emit('closeDialog', this.editedUser )
            this.$store.commit('mutate', { prop: 'snackbar', data: { text: 'Success!', value:true } })
          }).catch( (err) => {
            this.$store.commit('mutate', { prop: 'snackbar', data: { text: err.response.data.msg, value:true } })
          })
        }

      }
    }
  }
</script>

<style scoped>
</style>


